news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, AI교육기업으로 대전환 선언…“전국민 AI 성공시대 연다”</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌, AI교육기업으로 대전환 선언…“전국민 AI&nbsp;성공시대 연다”</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><strong>-&nbsp;에듀윌 AI프롬프트 연구소장으로 정진일 피플웨어 교육컨설팅그룹 대표 영입</strong></p>
                              <p><strong>- AI&nbsp;교육 생태계 구축… 패밀리 클래스부터 사용자협회까지</strong></p>
                              <p>&nbsp;</p>
                              <p> <figure class="image"><img src="//company.eduwill.net/contents/img/20250605144646.jpg"></figure></p>
                              <p><span style="font-family:'맑은 고딕';">▲사진설명:&nbsp;에듀윌 양형남 대표(왼쪽)가 에듀윌 AI프롬프트 연구소 정진일 소장에게 위촉장을 전달한 후 기념촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">(2025-05-26) 에듀윌이 AI교육기업으로의 대전환을 알리며,&nbsp;‘전국민 AI&nbsp;성공시대’를 열겠다고 선포했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">AI교육기업 에듀윌(대표 양형남)은 AI&nbsp;교육 및 생산성 분야 전문가인 정진일 피플웨어 교육컨설팅그룹 대표를 에듀윌 AI프롬프트 연구소장으로 전격 영입했다고 26일 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">정진일 신임 연구소장은 AI&nbsp;기반 역량 개발 및 생산성 향상에 정통한 교육 컨설턴트이자 전문 강사다. 기업 및 공공기관을 대상으로 AI교육과 디지털 전환 프로젝트를 다수 이끌어온 바 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌은 정진일 연구소장 영입을 시작으로 전 세대가 AI를 쉽게 배우고 실생활에 활용할 수 있도록 ▲AI&nbsp;패밀리 클래스 개설 ▲AI&nbsp;멤버십 프로그램 운영 ▲AI&nbsp;사용자협회 설립 등 입체적인 AI&nbsp;교육 생태계를 조성할 계획이다.&nbsp;또한 사내 직원 대상 AI&nbsp;교육을 통해 내부 생산성 혁신을 꾀하고,&nbsp;이를 기반으로 외부 컨설팅 사업으로도 확장한다는 전략이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">양형남 에듀윌 대표는 “AI를 통해 경쟁사와 차별화된 교육 시스템을 구축하고,&nbsp;글로벌 AI&nbsp;교육기업으로 도약하고자 한다”며 “정진일 소장을 중심으로 에듀윌이 AI&nbsp;교육의 선도 기업이 될 것으로 기대한다”고 말했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">정진일 소장은 “AI는 누구에게나 새로운 기회의 문을 열어주는 도구로,&nbsp;이제는 AI와의 협업이 필수가 된 시대”라며 “대기업 등 많은 기업들의 러브콜을 마다하고 합류한 만큼,&nbsp;에듀윌이 대한민국 AI&nbsp;교육의 전환점이자 중심 역할을 할 수 있도록 최선을 다하겠다”고 포부를 밝혔다.</span>
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news26" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌 공인중개사 교재, 예스24 베스트셀러 1~27위 석권</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news24" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 프레임아웃과 손잡고 AI 기반 디지털 혁신 추진</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
